import type { InputProps } from "@chakra-ui/react"
import { forwardRef, Input } from "@chakra-ui/react"

const FormInput = forwardRef<InputProps, "input">((props, ref) => (
  <Input
    ref={ref}
    borderRadius={"none"}
    py={8}
    {...props}
  />
))

export default FormInput
